// extracted by mini-css-extract-plugin
module.exports = {"slide":"_loading_slide_3ixT1","slide-reverse":"_loading_slide-reverse_1x7iI","loadingIcon":"_loading_loadingIcon_2KEMq"};